<script>
    import { push } from 'svelte-spa-router'
    import Hamburger from '../menu.svelte'

    import { fly } from "svelte/transition"

    // npm から取ってくる
    import { onMount, onDestroy } from 'svelte';
    // この component（ Numbers.svelte ）が消えても　最後の y値 が消えないように stores 保存 
    import { y_last } from "../stores1"

    let y_value;

    // この component（ Numbers.svelte ）が消えるときに発動
    onDestroy(() => {
        // 最後の y値 を保存
        y_last.set(y_value)
    })

    // この component が現れるときに発動
    onMount(() => {
        // y値 を 最後の y値（= $y_last）と同じにする
        y_value = $y_last
    })

    var menu_counter = 0
        let menu_status = "off"

    const hamburger = () => {
        menu_counter++
        if (menu_counter % 1) {
            menu_status = "on"
        } else {
            menu_status = "off"
        }
    }

    import Policy from '../policy.svelte'
    import { policy } from '../stores6'

    const openPolicy = () => {
        policy.set(true)
    }

    import { nightmode } from "../stores5"
</script>

<div class:night={$nightmode} style="padding-left:8px;">
    <header class="header" transition:fly="{{x: 200}}">
        <div class="header-space1"></div>
        <div class="header-title" on:click={() => push('/base1')}>第75回記念祭</div>
        <div class="header-space2"></div>
    </header>
    <div class="catch">
        <div class="catch-item1" transition:fly="{{x: 200}}"></div>
        <div class="catch-item2" class:catch-item3-night={$nightmode} transition:fly="{{x: -200}}">テーマ「共鳴」</div>
    </div>
    <div class="theme" class:theme-night={$nightmode} transition:fly="{{x: -200}}">
        <div class="theme-img-cover">
            <div class="theme-img" class:theme-img-night={$nightmode}></div>
        </div>
        <div class="theme-text-cover">
            <div class="theme-text">
                第75回記念祭テーマ「共鳴」は、西高の記念祭の原点に立ち返る、そして現状の西高への問題提起も含めたテーマになったと感じています。西高の記念祭の可能性は無限大です。なぜなら、それぞれが多様性に富んでいるから。記念祭の参加形態も幅が広く、また他校では気に留められないようなことも、記念祭で発信することが可能です。その多様性は記念祭という、いわば、一つの周波数で「共鳴」し合い、西高でしか出会えない人と出会い、成せない経験を紡ぎだします。記念祭テーマ「共鳴」には、西高の記念祭が変わらずお互いがお互いの好きなこと、得意なことを尊重し、自由に発信する場であってほしい、という私たち記実の強い想いが込められています。一方、コロナ渦でその発信の場である、授業、部活動、行事は自粛を余儀なくされています。そんな中でも時代の変動に委縮せず、エネルギッシュな西高生であり続けたい。そのエネルギーの象徴である、「共鳴」し合う記念祭を創っていきます。
            </div>
        </div>
        <div class="thme-text-writer">文：75th記念祭実行委員会</div>
    </div>
    <footer class="footer" transition:fly="{{x: -200}}">
        <div class="footer-title" on:click={() => push('/base1')}>第75回記念祭</div>
        <div class="policy" on:click={openPolicy}>プライバシーポリシー</div>
        <div class="footer-copyright">Copyright © 第75回記念祭 All Rights Reserved</div>
    </footer>
</div>

{#if menu_counter % 2 === 1}
<Hamburger/>
{/if}

{#if $policy}
<Policy/>
{/if}

<svelte:window bind:scrollY={y_value}/>

<style>
.night{
    background-color: #222831;
    color:#DDDDDD;
}
.header{
    display:flex;
    flex-wrap: wrap;
    width:100%;
}
.header-space1{
    flex-basis:44%;
}
.header-title{
    font-size:24px;
    font-weight: 400;
    text-align: right;
    letter-spacing: 5px;
    margin-top:16px;
    margin-bottom:16px;
    flex-basis:50%;
    font-family: 'Noto Sans JP';
    cursor: pointer;
}
.header-space2{
    flex-basis:6%;
}
.catch{
    position:relative;
    width:100%;
    height:580px;
    overflow: hidden;
}
.catch-item1{
    position:absolute;
    top:20px;
    right:-15px;
    width:80%;
    height:500px;
    background-image: url(https://i.ibb.co/sHMjHQx/kinensai-pic-8.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 16% 50%;
    filter: saturate(0%);
    border-radius: 20px;
}
.catch-item2{
    display:table;
    background-color: greenyellow;
    position:absolute;
    top:500px;
    left:2%;
    font-size:40px;
    letter-spacing:.05em;
}
.catch-item3-night{
    color:#222831;
}
.theme{
    width:85%;
    margin-left:2%;
    padding-bottom:30px;
    border-bottom:1px solid black;
}
.theme-night{
    border-bottom:1px solid #dddddd;
}
.theme-img-cover{
    position:relative;
    height:340px;
}
.theme-img{
    background-image:url(/img/kyoumei.png);
    background-size:contain;
    background-repeat: no-repeat;
    background-position:50% 50%;
    width:100%;
    height:300px;
    margin-bottom:40px;
}
.theme-img-night{
    background-image: url(/img/kyomei-white.png);
}
.theme-text{
    line-height: 1.6em;
    font-size:20px;
    -webkit-line-break: normal;
    line-break: normal;
    text-align: center;
}
.thme-text-writer{
    text-align: right;
    font-size:18px;
    margin-top:20px;
}
@media screen and (min-width:768px){
    .theme-img-cover{
        display:inline-block;
        width:45%;
        height:900px; /*ここは文章の長さで調節*/
    }
    .theme-text-cover{
        position:relative;
        height:1000px; /*ここは文章の長さで調節*/
        text-align: center;
    }
    .theme-img{
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform : translate(-50%,-50%);
        transform : translate(-50%,-50%);
        width:100%;
    }
    .theme-text-cover{
        display: inline-block;
        width:50%;
        height:900px; /*ここは文章の長さで調節*/
    }
    .theme-text{
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform : translate(-50%,-50%);
        transform : translate(-50%,-50%);
        width:100%;
    }
}
@media screen and (min-width:1024px){
    .theme-img-cover{
        display:inline-block;
        width:45%;
        height:700px; /*ここは文章の長さで調節*/
    }
    .theme-text-cover{
        position:relative;
        height:1000px; /*ここは文章の長さで調節*/
        text-align: center;
    }
    .theme-img{
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform : translate(-50%,-50%);
        transform : translate(-50%,-50%);
        width:100%;
    }
    .theme-text-cover{
        display: inline-block;
        width:50%;
        height:700px; /*ここは文章の長さで調節*/
    }
    .theme-text{
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform : translate(-50%,-50%);
        transform : translate(-50%,-50%);
        width:100%;
    }
}
.footer{
    padding:40px 10px 40px 2%;
}
.footer-title{
    text-align: left;
    font-size:26px;
    font-weight:300;
    cursor: pointer;
}
.footer-copyright{
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    margin:10px 0 0 0;
}
.policy{
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    margin:10px 0 0 0;
    cursor: pointer;
}
</style>